import React from 'react';
import { Col, Form } from 'antd';

const ResCol = ({
  span = 24,
  xs = 24,
  sm = 24,
  md,
  lg,
  xl,
  xxl,
  children,
  className,
  ...rest
}) => {
  if (!xs) {
    xs = 24;
  }

  if (!sm) {
    sm = 24;
  }

  if (!md) {
    md = span;
  }

  if (!lg) {
    lg = span;
  }

  return (
    <Col span={span} xs={xs} sm={sm} md={md} lg={lg} className={className}>
      <Form.Item {...rest}>{children}</Form.Item>
    </Col>
  );
};

export default ResCol;
